// extracted by mini-css-extract-plugin
export default {"privacy":"Dozer_privacy__TaZUA","listLink":"Dozer_listLink__eGW7+"};